import { render, staticRenderFns } from "./AppStep0.vue?vue&type=template&id=0f8864ec"
import script from "./AppStep0.vue?vue&type=script&lang=js"
export * from "./AppStep0.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports